import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from '@aag-development/becreatives-ui';
import { useThemeStore } from './theme.store';

type Props = React.PropsWithChildren;

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const themeStore = useThemeStore();

  return (
    <StyledThemeProvider theme={theme[themeStore.theme]}>
      <GlobalStyle theme={theme[themeStore.theme]} />

      {children}
    </StyledThemeProvider>
  );
};

export { ThemeProvider };
